import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";

export default function CategoryEntries() {
  const movieCount = movies.filter((m) => m.type === "movie").length;
  const tvCount = movies.filter((m) => m.type === "tv").length;

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
        <Link
          to="/category/movie"
          className="group flex items-center gap-5 rounded-lg border border-primary-200 bg-primary-50 p-5 transition-all duration-300 hover:border-primary-400 md:p-7 cursor-pointer"
        >
          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-600 text-background-50 md:h-16 md:w-16">
            <i className="ri-film-line text-2xl md:text-3xl" />
          </span>
          <div className="min-w-0">
            <h3 className="flex items-center gap-2 text-lg font-bold text-foreground-950 md:text-xl">
              电影频道
              <i className="ri-arrow-right-line text-primary-600 transition-transform group-hover:translate-x-1" />
            </h3>
            <p className="mt-1.5 text-sm text-foreground-600">
              动作、剧情、科幻、悬疑、爱情... 共 {movieCount} 部精选影片
            </p>
          </div>
        </Link>

        <Link
          to="/category/tv"
          className="group flex items-center gap-5 rounded-lg border border-accent-200 bg-accent-50 p-5 transition-all duration-300 hover:border-accent-400 md:p-7 cursor-pointer"
        >
          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-accent-500 text-background-50 md:h-16 md:w-16">
            <i className="ri-tv-2-line text-2xl md:text-3xl" />
          </span>
          <div className="min-w-0">
            <h3 className="flex items-center gap-2 text-lg font-bold text-foreground-950 md:text-xl">
              电视剧频道
              <i className="ri-arrow-right-line text-accent-600 transition-transform group-hover:translate-x-1" />
            </h3>
            <p className="mt-1.5 text-sm text-foreground-600">
              刑侦、都市、古装、医疗、奇幻... 共 {tvCount} 部精选剧集
            </p>
          </div>
        </Link>
      </div>
    </section>
  );
}